import script from "./AdminPricing.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPricing.vue?vue&type=script&setup=true&lang=js"

import "./AdminPricing.vue?vue&type=style&index=0&id=7e5e9098&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e5e9098"]])

export default __exports__